export default __webpack_public_path__ + "static/inovabra-footer-cc135edd08bf072a278f70a7db431168.png";